import { render, staticRenderFns } from "./gamerank-update-num.vue?vue&type=template&id=10c152be"
import script from "./gamerank-update-num.vue?vue&type=script&lang=js"
export * from "./gamerank-update-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports